module.exports = __webpack_public_path__ + "static/media/bedok-back.5b215192.png";